import { gql } from "@apollo/client";

export const GetDeviceTypes = gql`
  query GetDeviceTypes($token: String!, $customerID: ID!) {
    GetDeviceTypes(token: $token, customerID: $customerID) {
      id
      deviceType
    }
  }
`;

export const GetDeviceTypesNodeById = gql`
  query GetDeviceTypesNodeById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsDeviceTypes {
        id
        deviceType
      }
    }
  }
`;

export const ReOrderDeviceTypes = gql`
  mutation ReOrderDeviceTypes(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $input: [ReOrderDeviceTypes]!
  ) {
    ReOrderDeviceTypes(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      input: $input
    )
  }
`;
